<template>
	<div class="colab-template">
		<div class="colab-template-item">
			<img class="img-colab" src="@/assets/image-home/RJC_logo_dark.png" />
			<img class="img-colab" src="@/assets/image-home/ISO_certification.png" />
			<!-- <img class="img-colab sedex" src="@/assets/image-home/Sedex_logo.png" /> -->
		</div>
		<div class="colab-template-item">
			<img class="img-colab" src="@/assets/image-home/DITP-Photoroom.png" />
			<img class="img-colab sedex" src="@/assets/image-home/Sedex_logo.png" />
			<img
				class="img-colab thai-gem"
				src="@/assets/image-home/thai_gem_jewery_trader_association.png"
			/>
		</div>
	</div>
</template>
<script>
export default {
	methods: {},
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/colab';
@import '@/assets/scss/main';
</style>
